import { AnalyticEvent, AnalyticTracking } from '@core/entity/analytics/analytic-tracking';
import { isNullOrUndefined } from '../../entity/validation';

type MatomoActionEvent = 'trackEvent' | 'trackPageView' | 'setUserId' | 'setDocumentTitle' | 'setCustomUrl';

type MatomoAction = [MatomoActionEvent, ...(string | number)[]];

export class MatomoAnalyticService implements AnalyticTracking {
  trackPageView(pageTitle: string, url: string): void {
    this.executeAction(['setDocumentTitle', pageTitle]);
    this.executeAction(['setCustomUrl', url]);
    this.executeAction(['trackPageView']);
  }

  trackEvent(config: AnalyticEvent): void {
    const eventArray: MatomoAction = ['trackEvent', config.category, config.action];
    if (!isNullOrUndefined(config.name)) {
      eventArray.push(config.name);
    }
    if (!isNullOrUndefined(config.value)) {
      eventArray.push(config.value);
    }
    this.executeAction(eventArray);
  }

  setUserId(userId: string): void {
    this.executeAction(['setUserId', userId]);
  }

  private executeAction(action: MatomoAction): void {
    if (window._paq) {
      // this.ngZone.runOutsideAngular(() => {
      window._paq.push(action);
      // });
      return;
    }
  }
}
